<template>
    <v-container class="toggle animated document-view" fluid>
        <v-row dense>
            <v-col cols="12">
                <v-card elevation="3" :loading="loading">
                    <v-card-text v-if="showWorkload == false">
                        <v-alert
                            text="No prepared workload as of now"
                            type="warning"
                        ></v-alert>
                    </v-card-text>
                    <v-card-text v-if="showWorkload == true">
                        <v-row>
                            <v-col v-if="workLoadData.approved_status == null" cols="12" md="10">
                                <v-alert
                                    v-if="!dbs_core_time || !dbs_consultation_time"
                                    text="Please update your core time and consultation time to ensure that the workload will be approved! You can also add your educational preparation details."
                                    type="error"
                                    color="#E53935"
                                ></v-alert>
                                <v-alert
                                    v-if="dbs_core_time && dbs_consultation_time"
                                    text="You have successfully added your core time and consultation time. Thank you! You can also add your educational preparation details."
                                    type="success"
                                ></v-alert>
                            </v-col>
                            <v-col v-if="workLoadData.approved_status == null" cols="12" md="1" class="d-flex align-center justify-end">
                                <v-btn @click="saveCoreAndConsultationTime()" color="darkGreen" class="mr-2">Save</v-btn>
                            </v-col>
                            <v-col v-if="workLoadData.approved_status == null" cols="12" md="1" class="d-flex align-center justify-end">
                                
                                <v-menu
                                    v-model="openWorkloadRemarks"
                                    location="bottom center"
                                    offset-y
                                >
                                    <template #activator="{ props }">
                                        <v-badge v-if="workloadRemarksData.length > 0" color="red-accent-3" :content="workloadRemarksData.length">
                                            <v-btn
                                                v-bind="props"
                                                :color="openWorkloadRemarks ? '' : 'primary'"
                                                variant="flat"
                                                elevation="4"
                                                icon
                                            >
                                                <v-icon>{{ openWorkloadRemarks ? 'mdi-close' : 'mdi-comment-text-outline' }}</v-icon>
                                            </v-btn>
                                        </v-badge>
                                        <v-btn
                                            v-else
                                            v-bind="props"
                                            :color="openWorkloadRemarks ? '' : 'primary'"
                                            variant="flat"
                                            elevation="4"
                                            icon
                                        >
                                            <v-icon>{{ openWorkloadRemarks ? 'mdi-close' : 'mdi-comment-text-outline' }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card
                                        class="rounded-lg"
                                        style="display: flex; flex-direction: column; width: 400px;"
                                    >
                                        <v-card-title
                                            class="d-flex justify-space-between align-center"
                                            style="background-color: #1a5b0f !important;"
                                        >
                                            <div>
                                                <span class="font-weight-bold text-h6 text-white">Remarks</span>
                                            </div>
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                                            <v-timeline side="end">
                                                <v-card elevation="0" v-if="workloadRemarksData.length === 0" class="w-100">
                                                    <v-card-text>No remarks made yet</v-card-text>
                                                </v-card>
                                                <v-timeline-item
                                                    v-for="remarks in workloadRemarksData"
                                                    :key="remarks.id"
                                                    size="x-small"
                                                >
                                                    <v-alert border="start">
                                                        <div class="font-weight-bold font-italic">
                                                            "{{ remarks.details }}"
                                                        </div>
                                                        <br>
                                                        <div class="text-caption">
                                                            {{ getItemTitle(remarks.user_details) }} -
                                                            {{ formatDateTime(remarks.datecreated) }}
                                                        </div>
                                                        <div
                                                            v-if="remarks.user_details.id == $store.state.user.id"
                                                            class="mt-3"
                                                        >
                                                            <v-btn
                                                                @click="showEditRemarks(remarks)"
                                                                variant="flat"
                                                                color="orange-darken-1"
                                                            >
                                                                Edit
                                                            </v-btn>
                                                        </div>
                                                    </v-alert>
                                                </v-timeline-item>
                                            </v-timeline>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        <!-- <v-card-actions class="pa-3" style="margin-top: auto;">
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                class="mr-1"
                                                :loading="loading"
                                                text="Add Remarks"
                                                variant="elevated"
                                                elevation="1"
                                                color="darkGreen"
                                                @click="showAddRemarks()"
                                            ></v-btn>
                                        </v-card-actions> -->
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <v-col v-if="workLoadData.prepared_status == null" cols="12">
                                <v-card elevation="3">
                                    <v-card-text>
                                        <v-chip color="darkGreen">For Preparation</v-chip>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col v-if="workLoadData.prepared_status != null" cols="12" md="3">
                                <v-card elevation="3">
                                    <v-card-text>
                                        <div class="font-weight-bold">Prepared by:</div>
                                        <div v-for="preparer in workLoadData.preparer" :key="preparer">
                                            <div class="mt-4">{{ getItemTitle(preparer) }}</div>
                                            <div class="text-caption font-weight-bold">{{ preparer?.designation }}</div>
                                        </div>
                                        <div class="mt-4 text-caption">{{ formatDate(workLoadData.prepared_date) }}</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col v-if="workLoadData.recommending_approval_status != null" cols="12" md="3">
                                <v-card elevation="3">
                                    <v-card-text>
                                        <div class="font-weight-bold">Recommending Approval by:</div>
                                        <div v-for="recommender in workLoadData.recommenders" :key="recommender">
                                            <div class="mt-4">{{ getItemTitle(recommender) }}</div>
                                            <div class="text-caption font-weight-bold">{{ recommender?.designation }}</div>
                                        </div>
                                        <div class="mt-4 text-caption">{{ formatDate(workLoadData.recommending_approval_date) }}</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col v-if="workLoadData.pre_approved_status != null" cols="12" md="3">
                                <v-card elevation="3">
                                    <v-card-text>
                                        <div class="font-weight-bold">Pre Approved by:</div>
                                        <div class="mt-4">{{ getItemTitle(workLoadData.pre_approver) }}</div>
                                        <div class="text-caption font-weight-bold">{{ workLoadData.pre_approver?.designation }}</div>
                                        <div class="mt-4 text-caption">{{ formatDate(workLoadData.pre_approved_date) }}</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col v-if="workLoadData.approved_status != null" cols="12" md="3">
                                <v-card elevation="3">
                                    <v-card-text>
                                        <div class="font-weight-bold">Approved by:</div>
                                        <div class="mt-4">{{ getItemTitle(workLoadData.approver) }}</div>
                                        <div class="text-caption font-weight-bold">{{ workLoadData.approver?.designation }}</div>
                                        <div class="mt-4 text-caption">{{ formatDate(workLoadData.approved_date) }}</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-if="showWorkload == true" class="pa-8 document-card">
                        <v-row>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-4">
                                    <v-label color="black">Faculty:</v-label>
                                    <v-text-field
                                        v-model="faculty_name"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-4">
                                    <v-label>Employment Status:</v-label>
                                    <v-text-field
                                        v-model="employment_status"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-4">
                                    <v-label>Designation:</v-label>
                                    <v-text-field
                                        v-model="designation"
                                        :rules="[formRules.required]"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-4">
                                    <v-label>Rank:</v-label>
                                    <v-text-field
                                        v-model="rank"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-4">
                                    <v-label>Institute:</v-label>
                                    <v-text-field
                                        v-model="institute"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-4">
                                    <v-label>Department:</v-label>
                                    <v-text-field
                                        v-model="department"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-lg-8">
                            <v-col cols="12" md="8">
                                <v-row>
                                    <v-col cols="12" class="text-lg-left">
                                        <v-label class="font-weight-black text-black">Educational Preparation: <div class="text-caption text-gray">&nbsp; (You can edit this if your profile is not updated)</div></v-label>
                                    </v-col>
                                    <v-col cols="12" class="text-lg-right">
                                        <div class="d-flex flex-lg-row flex-column ga-2">
                                            <v-label>Bachelor's Degree:</v-label>
                                            <v-text-field
                                                v-model="undergraduate"
                                                color="darkGreen"
                                                variant="underlined"
                                                density="comfortable"
                                                class="font-weight-bold"
                                                hide-details
                                            ></v-text-field>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" class="text-lg-right">
                                        <div class="d-flex flex-lg-row flex-column ga-2">
                                        <v-label>Master's Degree:</v-label>
                                        <v-text-field
                                                v-model="graduate"
                                                color="darkGreen"
                                                variant="underlined"
                                                density="comfortable"
                                                class="font-weight-bold"
                                                hide-details
                                            ></v-text-field>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" class="text-lg-right">
                                        <div class="d-flex flex-lg-row flex-column ga-2">
                                            <v-label>Doctoral/Professional Degree:</v-label>
                                            <v-text-field
                                                v-model="post_graduate"
                                                color="darkGreen"
                                                variant="underlined"
                                                density="comfortable"
                                                class="font-weight-bold"
                                                hide-details
                                            ></v-text-field>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row v-if="team_teach_name != null" dense class="mt-lg-8">
                            <v-col cols="12" md="6">
                                <v-row>
                                    <v-col cols="12" class="text-lg-left">
                                        <v-label class="font-weight-black text-black">Team Teaching:</v-label>
                                    </v-col>
                                    <v-col cols="12" class="text-lg-right">
                                        <div class="d-flex flex-lg-row flex-column ga-2">
                                            <v-label>Faculty Name:</v-label>
                                            <v-text-field
                                                v-model="team_teach_name"
                                                readonly
                                                color="darkGreen"
                                                variant="underlined"
                                                density="comfortable"
                                                class="font-weight-bold"
                                                hide-details
                                            ></v-text-field>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" class="text-lg-right">
                                        <div class="d-flex flex-lg-row flex-column ga-2">
                                            <v-label>Bachelor's Degree:</v-label>
                                            <v-text-field
                                                v-model="team_teach_undergraduate"
                                                readonly
                                                color="darkGreen"
                                                variant="underlined"
                                                density="comfortable"
                                                class="font-weight-bold"
                                                hide-details
                                            ></v-text-field>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" class="text-lg-right">
                                        <div class="d-flex flex-lg-row flex-column ga-2">
                                            <v-label>Master's Degree:</v-label>
                                            <v-text-field
                                                v-model="team_teach_graduate"
                                                readonly
                                                color="darkGreen"
                                                variant="underlined"
                                                density="comfortable"
                                                class="font-weight-bold"
                                                hide-details
                                            ></v-text-field>
                                        </div>
                                    </v-col>
                                    <v-col v-if="team_teach_post_graduate" cols="12" class="text-lg-right">
                                        <div class="d-flex flex-lg-row flex-column ga-2">
                                            <v-label>Doctoral/Professional Degree:</v-label>
                                            <v-text-field
                                                v-model="team_teach_post_graduate"
                                                readonly
                                                color="darkGreen"
                                                variant="underlined"
                                                density="comfortable"
                                                class="font-weight-bold"
                                                hide-details
                                            ></v-text-field>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-8">
                            <v-col cols="12" md="6" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>Core Time:</v-label>
                                    <v-text-field
                                        v-model="core_time"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="6" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>Consultation Time:</v-label>
                                    <v-text-field
                                        v-model="consultation_time"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-card>    
                                    <v-data-table
                                        :mobile="isMobileOrTablet()"
                                        :headers="headers"
                                        :items="courseLoadData"
                                        :loading="loading"
                                        hide-default-footer
                                        class="text-caption"
                                    >
                                    <template v-slot:loading>
                                        <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                    </template>
                                   
                                    <template v-slot:item.datecreated="{ item }">
                                        <span>{{ formatDateTime(item.datecreated)}} </span>
                                    </template>
                                    <template v-slot:[`item.action`]="{ item }">
                                        <div class="d-flex flex-column justify-end ga-2 py-2">
                                            <v-btn @click="showFacultyLoadDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                        </div>
                                    </template>
                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-8 d-flex flex-column flex-lg-row ga-4">
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>Total Teaching Hours/Wk:</v-label>
                                    <v-text-field
                                        v-model="total_teaching_hours"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>Total No. of Preparation:</v-label>
                                    <v-text-field
                                        v-model="total_preparation"
                                        :rules="[formRules.required]"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row v-if="ms_load_eqv != 0" dense class="d-flex flex-column flex-lg-row ga-4">
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>Total MS Load Equivalent :</v-label>
                                    <v-text-field
                                        v-model="ms_load_eqv"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>Total  No. of MS Student:</v-label>
                                    <v-text-field
                                        v-model="ms_total_student"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row v-if="ge_load_eqv != 0" dense>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>Total GE Load Equivalent:</v-label>
                                    <v-text-field
                                        v-model="ge_load_eqv"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>Total  No. of GE Student:</v-label>
                                    <v-text-field
                                        v-model="ge_total_student"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row v-if="profed_load_eqv != 0" dense>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>Total ProfEd Load Equivalent :</v-label>
                                    <v-text-field
                                        v-model="profed_load_eqv"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>Total  No. of ProfEd Student:</v-label>
                                    <v-text-field
                                        v-model="profed_total_student"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row v-if="gs_load_eqv != 0" dense>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>Total GS Load Equivalent :</v-label>
                                    <v-text-field
                                        v-model="gs_load_eqv"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>Total  No. of GS Student:</v-label>
                                    <v-text-field
                                        v-model="gs_total_student"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-8">
                            <v-col cols="12">
                                <v-row dense align="center">
                                    <v-col cols="12" md="6">
                                        <span class="font-weight-bold text-h6">ADMIN Load Release</span>
                                    </v-col>
                                    <v-col cols="12" class="mt-1">
                                        <v-card>    
                                            <v-data-table
                                                :mobile="isMobileOrTablet()"
                                                :headers="loadHeaders"
                                                :items="adminLoadData"
                                                :loading="loading"
                                                hide-default-footer
                                                class="text-body-2"
                                            >
                                            <template v-slot:loading>
                                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                            </template>
                                            <template v-slot:item.description="{ item }">
                                                <div class="text-truncate" style="max-width: 800px;">
                                                    {{ item.description }}
                                                </div>
                                            </template>
                                            <template v-slot:item.datecreated="{ item }">
                                                <span>{{ formatDateTime(item.datecreated)}} </span>
                                            </template>
                                            <template v-slot:item.to_be_counted="{ item }">
                                                <v-icon v-if="item.to_be_counted == true" color="green">mdi-check</v-icon>
                                                <v-icon v-else color="red">mdi-close</v-icon>
                                            </template>
                                            <template v-slot:[`item.action`]="{ item }">
                                                <div class="d-flex justify-end ga-2">
                                                    <v-btn @click="showEditAdminLoadDialog(item)" size="x-small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                                    <v-btn  @click="showDeleteAdminDialog(item)" size="x-small" variant="outlined" text="Remove" color="red" elevation="3"></v-btn>
                                                </div>
                                            </template>
                                            <template v-slot:no-data>
                                                <span>No Admin Load Release</span>
                                            </template>
                                            </v-data-table>
                                        </v-card>
                                    </v-col>   
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-8">
                            <v-col cols="12">
                                <v-row dense align="center">
                                    <v-col cols="12" md="6">
                                        <span class="font-weight-bold text-h6">RDE Load Release</span>
                                    </v-col>
                                    <v-col cols="12" class="mt-1">
                                        <v-card>    
                                            <v-data-table
                                                :mobile="isMobileOrTablet()"
                                                :headers="repHeaders"
                                                :items="repLoadData"
                                                :loading="loading"
                                                hide-default-footer
                                                class="text-body-2"
                                            >
                                            <template v-slot:loading>
                                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                            </template>
                                            <template v-slot:item.rep_title.title="{ item }">
                                                <div style="max-width: 800px;">
                                                    <span >
                                                        {{ item.rep_title.title }}
                                                    </span>

                                                    <span v-if="item.rep_title.category == 'Res'"> (Res)</span>
                                                    <span v-if="item.rep_title.category == 'Ext'"> (Ext)</span>
                                                    <span v-if="item.rep_title.category == 'Prod'"> (Prod)</span>

                                                    <span>({{ item.role  }})</span>
                                                </div>
                                            </template>
                                            <template v-slot:item.datecreated="{ item }">
                                                <span>{{ formatDateTime(item.datecreated)}} </span>
                                            </template>
                                            <template v-slot:no-data>
                                                <span>No RDE Load Release</span>
                                            </template>
                                            </v-data-table>
                                        </v-card>
                                    </v-col>   
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-8">
                            <v-col cols="12" md="8" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>TOTAL IREPA (Instruction, Research, Extension, Production and Administrative) LOAD UNITS/WK:</v-label>
                                    <v-text-field
                                        v-model="total_irepa_units"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="8" class="text-lg-right">
                                <div class="d-flex flex-lg-row flex-column ga-2">
                                    <v-label>TOTAL IREPA (Instruction, Research, Extension, Production and Administrative) LOAD HOURS/WK:</v-label>
                                    <v-text-field
                                        v-model="total_irepa_hours"
                                        color="darkGreen"
                                        variant="underlined"
                                        density="comfortable"
                                        class="font-weight-bold"
                                        readonly
                                        hide-details
                                    ></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import WorkloadRemarkDialog from '@/components/Dialogs/Sub-Dialogs/WorkloadRemarkDialog.vue';

export default defineComponent({
    components: {
        WorkloadRemarkDialog
    },
    data () {
        return {
            loading: false,

            id: null,
            user_id: null,
            faculty_name: null,
            employment_status: null,
            designation: null,
            rank: null,
            institute: null,
            department: null,
            undergraduate: null,
            graduate: null,
            post_graduate: null,
            team_teach_name: null,
            team_teach_undergraduate: null,
            team_teach_graduate: null,
            team_teach_post_graduate: null,
            core_time: null,
            consultation_time: null,
            total_teaching_hours: null,
            total_preparation: null,
            ms_load_eqv: null,
            ms_total_student: null,
            ge_load_eqv: null,
            ge_total_student: null,
            profed_load_eqv: null,
            profed_total_student: null,
            gs_load_eqv: null,
            gs_total_student: null,
            total_irepa_units: null,
            total_irepa_hours: null,

            dbs_core_time: null,
            dbs_consultation_time: null,

            showWorkload: false,
            courseLoadData: [],
            adminLoadData: [],
            repLoadData: [],
            workLoadData: [],
            officeName: 'Office of the Vice President for Academic Affairs',

            headers: [
                { title: 'Course No.', align: 'center', sortable: false, key: 'code' },
                { title: 'Course Title', align: 'center', sortable: false, key: 'title' },
                { title: 'Unit', align: 'center', sortable: false, key: 'unit' },
                { title: 'Time', align: 'center', sortable: false, key: 'time' },
                { title: 'Day', align: 'center', sortable: false, key: 'day' },
                { title: 'Room', align: 'center', sortable: false, key: 'room' },
                { title: 'Program/Section', align: 'center', sortable: false, key: 'section_code' },
                { title: 'Class Size', align: 'center', sortable: false, key: 'class_size' },
                { title: 'Hours Lec (a)', align: 'center', sortable: false, key: 'hours_lecture' },
                { title: 'Hours Lab', align: 'center', sortable: false, key: 'hours_lab' },
                { title: 'Actual Contact Teaching Hrs/Wk', align: 'center', sortable: false, key: 'actual_contact_teaching' },
                { title: '.75 Eqv (b)', align: 'center', sortable: false, key: 'eqv' },
                { title: 'Total Load Eqv', align: 'center', sortable: false, key: 'total_eqv' },
                // { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            loadHeaders: [
                { title: 'SO No.', align: 'center', sortable: false, key: 'so_number' },
                { title: 'Description', align: 'center', sortable: false, key: 'description' },
                { title: 'Hours', align: 'center', sortable: false, key: 'hours' },
                { title: 'Unit', align: 'center', sortable: false, key: 'unit' },
                { title: 'To Be Counted', align: 'center', sortable: false, key: 'to_be_counted' },
                // { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            repHeaders: [
                { title: 'SO No.', align: 'center', sortable: false, key: 'so_number' },
                { title: 'Description', align: 'center', sortable: false, key: 'rep_title.title' },
                { title: 'Hours', align: 'center', sortable: false, key: 'unit_loading' },
                { title: 'Unit', align: 'center', sortable: false, key: 'unit_loading' },
            ],

            workloadRemarksData: [],
            openWorkloadRemarks: false,
        }
    },
    methods: {
        init(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-workload/findAllLoadByUserAndSemesterSchoolyear/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    if(res.data.length === 0){
                        this.showWorkload = false
                        this.loading = false
                    }
                    else{
                        this.showWorkload = true
                        this.workLoadData = res.data[0]
                        this.initUser(res.data[0])
                    }
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async initUser(data){
            this.id = data.id
            this.user = data.user
            this.user_id = data.user_id
            this.faculty_name = data.faculty_name
            this.employment_status = data.employment_status
            this.designation = data.designation
            this.rank = data.rank
            this.institute = data.institute
            this.department = data.department
            this.undergraduate = data.undergraduate
            this.graduate = data.graduate
            this.post_graduate = data.post_graduate
            this.team_teach_name = data.team_teach_name
            this.team_teach_undergraduate = data.team_teach_undergraduate,
            this.team_teach_graduate = data.team_teach_graduate,
            this.team_teach_post_graduate = data.team_teach_post_graduate,
            this.core_time = data.core_time
            this.consultation_time = data.consultation_time
            this.dbs_core_time = data.core_time
            this.dbs_consultation_time = data.consultation_time

            this.vpaa_staff_code = data.vpaa_staff_code

            await this.loadCourseLoad()

            this.total_teaching_hours = data.total_teaching_hours
            this.total_preparation = data.total_preparation
            this.ms_load_eqv = data.ms_load_eqv
            this.ms_total_student = data.ms_total_student
            this.ge_load_eqv = data.ge_load_eqv
            this.ge_total_student = data.ge_total_student
            this.profed_load_eqv = data.profed_load_eqv
            this.profed_total_student = data.profed_total_student
            this.gs_load_eqv = data.gs_load_eqv
            this.gs_total_student = data.gs_total_student

            await this.loadReleaseLoad()

            this.total_irepa_units = data.total_irepa_units
            this.total_irepa_hours = data.total_irepa_hours

            this.loading = false
        },
        async loadCourseLoad(){
            if (this.workLoadData?.is_snapshot_locked) {
                this.courseLoadData = Array.isArray(this.workLoadData?.course_load_snapshot)
                    ? this.workLoadData.course_load_snapshot
                    : [];
                return;
            }
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-load/findAllBySemesterAndSchoolyear/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.courseLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async loadReleaseLoad(){
            if (this.workLoadData?.is_snapshot_locked) {
                this.adminLoadData = Array.isArray(this.workLoadData?.admin_load_snapshot)
                    ? this.workLoadData.admin_load_snapshot
                    : [];
                this.repLoadData = Array.isArray(this.workLoadData?.rep_load_snapshot)
                    ? this.workLoadData.rep_load_snapshot
                    : [];
                return;
            }
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/admin-load/findAllLoadByUserAndSemester/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.adminLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/rep-unit-load/findAllLoadByUserAndSemester/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.repLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        saveCoreAndConsultationTime(){
            const { showSnackbar } = useSnackbar()
            let formData = {
                id: this.id,
                core_time: this.core_time,
                consultation_time: this.consultation_time,
                undergraduate: this.undergraduate,
                graduate: this.graduate,
                post_graduate: this.post_graduate
            }

            const token = localStorage.getItem('aums-token')
            axios.post(process.env.VUE_APP_SERVER_URL + '/faculty-workload/updateCoreandConsultationTime', formData,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 200){
                    showSnackbar('Workload successfully updated!')
                    this.init()
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            })
        },
        getItemTitle(item) {
            return `${item?.fname ?? ''} ${item?.mname ? item?.mname[0] + '.' : ''} ${item?.lname ?? ''}${item?.suffix ? ' ' + item?.suffix : ''}${item?.post_nominal ? ', ' + item?.post_nominal : ''}`;
        },
        getRepCategory(category){
            if(category == 'Res'){
                return '(Res)'
            }
            else if(category == 'Ext'){
                return '(Ext)'
            }
            else if(category == 'Pro'){
                return '(Prod)'
            }
        },
        getRepRole(role){
            if(role == 'Member'){
                return '(Member)'
            }
            else if(role == 'Leader'){
                return '(Leader)'
            }
        },
        async loadWorkloadRemarks(){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-workload-remarks/findAllRemarksByWorkloadId/' + this.workLoadData?.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.workloadRemarksData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        showAddRemarks(){
            this.$refs.WorkloadRemarkDialog.initAdd(this.workLoadData.id)
        },
        showEditRemarks(data){
            this.$refs.WorkloadRemarkDialog.initUpdate(data)
        },
    },
    mounted(){
        this.init()
        this.$nextTick(() => {
            if (this.workLoadData?.id) {
                this.loadWorkloadRemarks()
            }
        })
    },
    watch: {
        workLoadData: {
            handler(newVal) {
                if (newVal?.id) {
                    this.loadWorkloadRemarks()
                }
            },
            immediate: true
        }
    }
})
</script>

<style scoped>
.document-view {
    background: #f3f3f3;
    padding: 16px;
}

:deep(.document-card) {
    background: #ffffff;
    border-radius: 2px;
    box-shadow: none !important;
    font-size: 13px;
    line-height: 1.25;
    font-family: "Arial", "Helvetica", sans-serif;
}

:deep(.document-card .v-card-text) {
    border-top: 1px solid #d0d0d0;
    padding-top: 10px;
    padding-bottom: 10px;
}

:deep(.document-card .v-card-text:first-of-type) {
    border-top: 0;
}

/* Give form controls a printable/manual-document feel while staying editable */
:deep(.document-card .v-field) {
    border-radius: 2px;
    background: #fff;
    box-shadow: none !important;
}

:deep(.document-card .v-field__overlay),
:deep(.document-card .v-field__underlay) {
    display: none;
}

:deep(.document-card .v-field__input) {
    min-height: 32px;
    padding-top: 4px;
    padding-bottom: 4px;
    color: #111;
    font-weight: 600;
    font-size: 12px;
}

/* Tighten Vuetify underlined field spacing so text sits closer to the underline */
:deep(.document-card .v-input) {
    margin-top: 0px !important;
}

:deep(.document-card .v-field--variant-underlined .v-field__input) {
    min-height: 24px !important;
    padding-top: 0 !important;
    padding-bottom: 1px !important;
    line-height: 1.15 !important;
    display: flex;
    align-items: flex-end;
}

:deep(.document-card .v-field--variant-underlined .v-field__field) {
    align-items: flex-end;
}

:deep(.document-card .v-label) {
    color: #111;
    font-weight: 700;
    font-size: 12px;
}

:deep(.document-card .v-alert) {
    border: 1px solid #444;
    border-radius: 2px;
}

/* Document-like table grid */
:deep(.document-card .v-table) {
    border: 1px solid #333;
    border-radius: 0;
}

:deep(.document-card .v-table table) {
    border-collapse: collapse;
}

:deep(.document-card .v-table thead tr th),
:deep(.document-card .v-table tbody tr td) {
    border: 1px solid #333 !important;
    color: #111;
    font-size: 12px;
    padding: 6px 8px !important;
}

:deep(.document-card .v-table thead tr th) {
    background: #f5f5f5;
    font-weight: 700;
    line-height: 1.15;
}

:deep(.document-card .v-data-table thead th) {
    background: #efefef !important;
    color: #000 !important;
    opacity: 1 !important;
}

:deep(.document-card .v-data-table thead th .v-data-table-header__content) {
    color: #000 !important;
    font-weight: 700 !important;
    font-size: 11px;
    white-space: normal;
    line-height: 1.2;
}

:deep(.document-card .v-data-table thead th .v-icon) {
    display: none !important;
}

:deep(.document-card .v-btn) {
    border-radius: 2px;
    letter-spacing: 0;
    font-size: 11px;
    min-height: 28px;
    padding: 0 10px;
}

:deep(.document-card .v-chip) {
    border-radius: 2px;
    border: 1px solid #245f20;
    font-size: 11px;
    height: 24px;
}

:deep(.document-card .text-h6) {
    font-size: 15px !important;
    line-height: 1.2 !important;
}

:deep(.document-card .text-body-2),
:deep(.document-card .text-body-1),
:deep(.document-card .text-caption) {
    font-size: 12px !important;
    line-height: 1.2 !important;
}

:deep(.document-card .font-weight-bold) {
    letter-spacing: 0;
}

/* Unified label/input layout across the editable form section */
:deep(.doc-form-section .d-flex.flex-lg-row.flex-column) {
    display: grid !important;
    grid-template-columns: 220px minmax(0, 1fr);
    column-gap: 10px;
    align-items: end;
}

:deep(.doc-form-section .d-flex.flex-lg-row.flex-column .v-label) {
    justify-self: end;
    align-self: end;
    margin-bottom: 1px;
    white-space: nowrap;
}

:deep(.doc-form-section .d-flex.flex-lg-row.flex-column .v-input) {
    margin-top: 0 !important;
}

:deep(.doc-form-section .v-field--variant-underlined .v-field__input) {
    min-height: 24px !important;
    padding-top: 0 !important;
    padding-bottom: 1px !important;
    line-height: 1.15 !important;
    display: flex;
    align-items: flex-end;
}

:deep(.doc-form-section .v-field--variant-underlined .v-field__field) {
    align-items: flex-end;
}

:deep(.doc-form-section .v-col > .v-row.align-center) {
    display: grid;
    grid-template-columns: 220px minmax(0, 1fr);
    column-gap: 10px;
    align-items: end;
}

:deep(.doc-form-section .v-col > .v-row.align-center > .v-col:first-child) {
    max-width: 100% !important;
    flex: initial !important;
    justify-self: end;
    align-self: end;
    padding-top: 0;
    padding-bottom: 0;
}

:deep(.doc-form-section .v-col > .v-row.align-center > .v-col:last-child) {
    max-width: 100% !important;
    flex: initial !important;
    padding-top: 0;
    padding-bottom: 0;
}

@media (max-width: 960px) {
    :deep(.doc-form-section .d-flex.flex-lg-row.flex-column) {
        grid-template-columns: 1fr;
        row-gap: 4px;
    }

    :deep(.doc-form-section .d-flex.flex-lg-row.flex-column .v-label) {
        justify-self: start;
    }

    :deep(.doc-form-section .v-col > .v-row.align-center) {
        grid-template-columns: 1fr;
        row-gap: 4px;
    }

    :deep(.doc-form-section .v-col > .v-row.align-center > .v-col:first-child) {
        justify-self: start;
    }
}

@media (max-width: 768px) {
    .document-view {
        padding: 8px;
    }
}

</style>